import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/c7ca1cd9-942c-41a6-a724-9a8ab077dd81.png" 
              alt="Zimmetle.com Logo" 
              className="h-10 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('solutions')}
              className="text-[#1A2B4A] font-medium hover:text-[#FF6B35] transition-colors relative group cursor-pointer whitespace-nowrap"
            >
              Çözümler
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#FF6B35] transition-all group-hover:w-full"></span>
            </button>
            <button
              onClick={() => scrollToSection('integration')}
              className="text-[#1A2B4A] font-medium hover:text-[#FF6B35] transition-colors relative group cursor-pointer whitespace-nowrap"
            >
              Entegrasyonlar
            </button>
            <button
              onClick={() => scrollToSection('roadmap')}
              className="text-[#1A2B4A] font-medium hover:text-[#FF6B35] transition-colors relative group cursor-pointer whitespace-nowrap"
            >
              Yol Haritası
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-[#1A2B4A] font-medium hover:text-[#FF6B35] transition-colors relative group cursor-pointer whitespace-nowrap"
            >
              İletişim
            </button>
          </div>

          <div className="flex items-center space-x-4">
            <button 
              onClick={() => scrollToSection('contact')}
              className="px-6 py-2.5 bg-[#FF6B35] text-white rounded-lg font-medium hover:bg-[#FF5722] transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              Demo Talep Et
            </button>
          </div>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
